<template>
    <div class='cc-main'>
        <van-cell class='cc-main__content-wrapper'>
            <div class='cc-main__header'>
                <!-- card title start -->
                <!-- CardTitle或让Vant Cell来实现，或自己通过#title插槽实现 -->
                <van-cell
                    v-if="title"
                    :title="title"
                    :value="value"
                    :is-link="isLink"
                    :center="true"
                    :to="to"
                    @click="onClick"
                >
                    <!-- right icon -->
                    <template #right-icon v-if="rightIcon">
                        <van-icon :name="rightIcon ? rightIcon : ''"/>
                    </template>
                </van-cell>
                <slot class='cc-main__header' v-else-if="this.$scopedSlots.title" name="title"></slot>
                <!-- card title end -->
            </div>
            <slot></slot>
        </van-cell>
    </div>
</template>

<script>
import {CellGroup, Cell, Icon} from 'vant';
export default {
    name: 'cell-card',
    components: {
        [CellGroup.name]: CellGroup,
        [Cell.name]: Cell,
        [Icon.name]: Icon
    },
    props: {
        title: String,
        value: String,
        isLink: Boolean,
        rightIcon: [String, Boolean],
        onClick: Function,
        to: String
    },
    data() {
        return {};
    },
    mounted() {
    }
}
</script>

<style lang='less'>
@import '@/style/base.less';


.cc-main {
    padding: 8px 8px 0 8px;
}
.cc-main__content-wrapper {
    background-color: white;
    border-radius: 8px;
    overflow: hidden;
    padding: 0px;
}

.cc-main__header {

    .van-cell {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        overflow: hidden; 
    }

    .van-cell__title {
        font-size: @font-size-title;
        color: @font-color-title;
        line-height: @line-height-title;
        font-weight: @font-weight-title;
    }

    &.van-cell::after {
        border-bottom: none;
    }
}


</style>